import { render } from "./Main.vue?vue&type=template&id=2016ca10"
const script = {}
script.render = render

export default script